module.exports = __webpack_public_path__ + "img/tunisia.b67b898a.png";